// net-error.js — classify a thrown error as a NETWORK failure vs a real server
// error. Pure, dependency-free, so it is unit-testable and reusable across the
// offline-capable write surfaces (P7a: Reception's offline walk-in defers the
// online duplicate check on a network failure, but a real 4xx/5xx must still fail
// loud — the offline capture is safe, a bad request is not).
//
// A NETWORK failure is: navigator is offline, OR the throw is a fetch() TypeError
// (which carries NO HTTP status — "Failed to fetch" / "Load failed" / "NetworkError"),
// OR a message that matches those shapes. A real HTTP error carries a numeric
// `status` >= 400 (Medplum's OperationOutcomeError, our own 4xx/5xx) and is NEVER
// treated as a network failure — the caller keeps its fail-loud path.

/**
 * @param {unknown} ex a caught error
 * @returns {boolean} true when the failure is a transport/offline network failure
 */
export function isNetworkError(ex) {
  // A real HTTP error (has a numeric status) is NOT a network failure — fail loud.
  if (ex && typeof ex === 'object' && typeof ex.status === 'number' && ex.status >= 400) return false;
  // Explicitly offline → network.
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return true;
  // fetch() rejects with a TypeError on a transport failure (no status).
  if (ex instanceof TypeError) return true;
  const msg = String((ex && ex.message) || ex || '');
  return /failed to fetch|networkerror|load failed|network request failed/i.test(msg);
}
